module.exports = __webpack_public_path__ + "img/chair-de-poule.107f52e6.jpg";